// External libraries
import { Breakpoints } from '@zocdoc-frontend-common/styles-grid';

export default function isMobileBreakpoint() {
    return (
        typeof window !== 'undefined' && window.innerWidth < Breakpoints.small
    );
}
